import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// Слой дизайн-системы: токены + глобальные стили + анимации (side-effect import
// запускает подключение CSS). Импортируется ПОСЛЕ App (там грузится bootstrap),
// чтобы наши токены имели приоритет.
import { ThemeProvider } from './style';
import UiThemeBridge from './app/providers/UiThemeBridge';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './App';
import { OptionsProvider } from './OptionsContext';
import { AnalogsProvider } from './AnalogsContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 1 минута кэширования
      cacheTime: 1000 * 60 * 30, // 5 минут хранения кэша в памяти
      refetchOnWindowFocus: false, // Отключить рефетчинг при фокусе окна
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <QueryClientProvider client={queryClient}>
    <ThemeProvider>
      <UiThemeBridge>
        <BrowserRouter>
          <OptionsProvider>
            <AnalogsProvider>
              <AuthProvider>
                <App />
              </AuthProvider>
            </AnalogsProvider>
          </OptionsProvider>
        </BrowserRouter>
      </UiThemeBridge>
    </ThemeProvider>
  </QueryClientProvider>
    
);
